/**
 * M7 S35: story items in the cargo view (spec §2.8: sealed, never for sale). A story item's hold mirror (`story:<id>`,
 * `story: true`) shows under its own name, priced "Sealed", with the sealed note, instead of as anonymous contract
 * cargo. Names and labels: `storyHud.json` (`items`, `sealed`). UI events only.
 */
import type { CargoComponent } from '../../career/types'
import { storyItemIdOfComponent } from '../../story/items'
import raw from './storyHud.json'

export interface SealedItemRow {
  name: string
  priceLabel: string
  note: string
}

const items: Readonly<Record<string, string>> = raw.items
const sealed = raw.sealed

/** The cargo row text of a story item's mirror, or null for any other component. */
export function sealedItemRow(c: Readonly<CargoComponent>): SealedItemRow | null {
  if (c.story !== true) return null
  const id = storyItemIdOfComponent(c.id)
  return { name: (id === null ? undefined : items[id]) ?? sealed.price, priceLabel: sealed.price, note: sealed.note }
}
